<script>
import { makeID } from '../Modules/Strings.js';
import tippy from 'tippy.js';

export default {
  props: {
    className: String,
    name: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      id: null,
    };
  },

  computed: {
    iconId() {
      return 'icon-' + this.id;
    },

    calculateClass() {
      let className = 'btn ';
      if (this.className !== undefined && this.className.length > 0) {
        return className + this.className;
      }
      return className + ' btn-primary';
    },
  },

  created() {
    this.id = makeID(10);
  },
  mounted() {
    if (this.tooltip.length > 0) {
      let icon = tippy('#' + this.iconId, {
        content: this.tooltip,
      });
    }
  },
};
</script>

<template>
  <button :id="iconId" type="button" :class="calculateClass" :disabled="disabled">
    {{ name }}
    <slot />
  </button>
</template>
